import Stack from "@pathwright/ui/src/components/stack/Stack"
import { usePathwrightContext } from "@pathwright/web/src/modules/pathwright/PathwrightContext"
import ProfileAvatarCardTrigger from "@pathwright/web/src/modules/profile/ProfileAvatarCardTrigger"
import { canEditLibrary } from "@pathwright/web/src/modules/user/permissions"
import PropTypes from "prop-types"

const AnaltyicsAvatarsStack = function (
  { analytics, limit, itemWidth, itemOffset },
  { permissions }
) {
  const pwContext = usePathwrightContext()

  if (!analytics || !analytics.students_here) return null

  return (
    <Stack
      items={analytics.students_here
        .filter((user) => user.id !== pwContext.me?.id)
        .slice(0, limit)}
      itemWidth={itemWidth}
      itemOffset={itemOffset}
      // TODO: check cohort settings for if learner/observer can access Community > Members
      hoverable={canEditLibrary(pwContext)}
    >
      {({ item, itemWidth }) => (
        <ProfileAvatarCardTrigger
          user={item}
          // TODO: check cohort settings for if learner/observer can access Community > Members
          canViewCard={!!permissions && permissions.can_facilitate}
          canViewProfile={canEditLibrary(pwContext)}
          size={itemWidth}
        />
      )}
    </Stack>
  )
}

AnaltyicsAvatarsStack.displayName = "AnaltyicsAvatarsStack"

AnaltyicsAvatarsStack.contextTypes = { permissions: PropTypes.object }

export default AnaltyicsAvatarsStack
